// extracted by mini-css-extract-plugin
export default {"container":"CheckoutError_container__hkFjN","message":"CheckoutError_message__1v0q5","button":"CheckoutError_button__7z6gg"};